import { Fragment, JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Divider } from '@treezor/design-system';

import { SummaryInformationCategory, TCategory } from './SummaryInformationCategory';

export type TSection =
  | {
      component: JSX.Element;
      categories?: never;
      subTitle?: never;
    }
  | {
      component?: never;
      categories: TCategory[];
      subTitle?: string;
    };

export type TSummaryInformation = {
  title: string;
  sections: TSection[];
  className?: string;
};

export function SummaryInformation({ title, sections, className }: TSummaryInformation) {
  return (
    <div className={twMerge('flex flex-col gap-6', className)}>
      <h5 className="text-secondary typo-h5-bold font-bold">{title}</h5>
      <div className="rounded-200 p-6 flex flex-col gap-6 border-solid border-primary border-2">
        {sections.map((section, sectionIndex) => (
          <Fragment key={`section-component-${sectionIndex}`}>
            {section.component ? (
              <div>{section.component}</div>
            ) : (
              <div className="flex gap-7" key={`section-${sectionIndex}`}>
                {section.subTitle && (
                  <div key={`wrap-subtitle-${sectionIndex}`} className="w-[148px]">
                    <h6 className="text-secondary typo-h6-bold font-bold" key={`subtitle-${sectionIndex}`}>
                      {section.subTitle}
                    </h6>
                  </div>
                )}
                <div className="flex flex-col gap-4 w-full" key={`section-wrapper-${sectionIndex}`}>
                  {section.categories.map((category, categoriesIndex) => (
                    <>
                      <SummaryInformationCategory {...category} key={`category-${categoriesIndex}`} />
                      {categoriesIndex !== section.categories.length - 1 && (
                        <Divider thickness="200" key={`category-divider-${categoriesIndex}`} />
                      )}
                    </>
                  ))}
                </div>
              </div>
            )}
            {sectionIndex !== sections.length - 1 && (
              <Divider thickness="200" key={`section-divider-${sectionIndex}`} />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}
